import { Text, View, StyleSheet, Image, Font } from "@react-pdf/renderer";
import React from "react";

const HeartToSoul = require("../../Assets/Images/HeartToSoul.png");
const HeartToSoul2 = require("../../Assets/Images/HeartToSoul2.png");
const LatoRegular = require("../../Assets/Fonts/Lato-Font/Lato-Regular.ttf");
const LatoBold = require("../../Assets/Fonts/Lato-Font/Lato-Bold.ttf");

Font.register({
  family: "Lato",
  fonts: [
    { src: LatoRegular, fontWeight: 400 },
    { src: LatoBold, fontWeight: 700 },
  ],
});

const styles = StyleSheet.create({
  coverSection: {
    display: "flex",
    fontFamily: "Lato",
  },
  maincontent: {
    fontWeight: "700",
    fontSize: "18px",
    lineHeight: "30px",
    color: "#426B88",
    fontFamily: "Lato",
    alignItems: "flex-start",
    marginBottom: "5px",
    textTransform: "uppercase",
  },
  topSection: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-between",
    width: "100%",
  },
  coverTitle: {
    fontSize: "18px",
    fontWeight: 700,
    lineHeight: "30px",
    color: "#426B88",
  },
  contentContainer: {
    textAlign: "left",
    maxWidth: "800px",
    marginTop: "30px",
  },
  highlightText: {
    fontWeight: "700",
    fontSize: "14px",
    lineHeight: "22px",
    color: "#34495E",
    marginBottom: "5px",
  },
  paragraph: {
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "18px",
    color: "#245775",
    textAlign: "justify",
  },
  coverImage: {
    width: "50%",
    maxWidth: "220px",
  },
  textContent: {
    marginLeft: "20px",
  },
  pointsSection: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    marginVertical: "15px",
  },
  pointGroup: {
    width: "48%",
  },
  imgContainer: {
    alignItems: "center",
    justifyContent: "center",
  },
  bottomImage: {
    width: "100%",
    width: "330px",
    height: "110px",
  },
  text: {
    fontWeight: "700",
    fontSize: "12px",
    lineHeight: "18px",
    color: "#245775",
    marginTop: "10px",
    fontFamily: "Lato",
  },
  SubTitle: {
    fontWeight: "700",
    fontSize: "18px",
    lineHeight: "30px",
    color: "#426B88",
  },
  pointsContainer: {
    width: "100%",
    textAlign: "center",
    marginLeft: "20px",
    marginTop: "10px",
  },
  pointsHeader: {
    fontWeight: "700",
    fontSize: "12px",
    color: "#245775",
    lineHeight: "18px",
    fontFamily: "Lato",
    marginBottom: "8px",
    textAlign: "left",
  },
  pointsSection: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
  },
  pointGroup: {
    width: "45%",
    textAlign: "left",
  },
  pointText: {
    fontWeight: "400",
    fontSize: "12px",
    color: "#245775",
    lineHeight: "18px",
    marginBottom: "4px",
  },
});

const QuadrantFlowSecondPage360 = () => {
  return (
    <View style={styles.coverSection}>
      <Text style={styles.maincontent}>Quadrant Flow 360</Text>
      <View style={styles.topSection}>
        <Image src={HeartToSoul} style={styles.coverImage} />
        <View>
          <View style={styles.textContent}>
            <Text style={styles.coverTitle}>YOU FLOW FROM HEART TO SOUL</Text>
            <Text style={styles.SubTitle}>Feels good. But why?</Text>
          </View>
          <View style={styles.pointsContainer}>
            <Text style={styles.pointsHeader}>Possible Archetypes</Text>
            <View style={styles.pointsSection}>
              <View style={styles.pointGroup}>
                <Text style={styles.pointText}>• Deep Connector</Text>
                <Text style={styles.pointText}>• Authentic Sage</Text>
                <Text style={styles.pointText}>• Qualitative Advocate</Text>
              </View>
              <View style={styles.pointGroup}>
                <Text style={styles.pointText}>• Impractical Feeler</Text>
                <Text style={styles.pointText}>• Complicated Connector</Text>
                <Text style={styles.pointText}>• Idealistic Dreamer</Text>
              </View>
            </View>
          </View>
        </View>
      </View>

      <View style={styles.contentContainer}>
        <Text style={styles.paragraph}>
          This type of person is grounded in feelings and meaning, valuing inner
          experiences and simply "being" over outward actions and achievements.
        </Text>
        <Text style={styles.paragraph}>
          Heart-to-Soul individuals are guided by identity, values, and purpose.
          Rather than leading from the front, they create environments where
          life, love, and leadership can flourish naturally.
        </Text>
        <Text style={styles.paragraph}>
          Often seen as poets or creatives, they focus on soulful, intangible
          influence rather than conventional, straightforward strategies.
        </Text>
      </View>

      <View style={styles.imgContainer}>
        <Text style={styles.text}>Your Quadrant Flow - Self is:</Text>
        <Image src={HeartToSoul2} style={styles.bottomImage} />
        <Text style={styles.text}>Your Quadrant Flow - 360 is:</Text>
        <Image src={HeartToSoul2} style={styles.bottomImage} />
      </View>
    </View>
  );
};

export default QuadrantFlowSecondPage360;
